import { endpoint } from 'services/endpoint';
import { http } from 'services/http';

import { IAdvertisingApi } from './types';

export const advertising: IAdvertisingApi = {
  getChannels: (params) =>
    http.get(endpoint.advertising.GET_CHANNELS, { params }).then((res) => res.data),

  getDashboard: (params) =>
    http.get(endpoint.advertising.GET_DASHBOARD, { params }).then((res) => res.data),

  getPosts: (params) =>
    http.get(endpoint.advertising.GET_POSTS, { params }).then((res) => res.data),

  getPost: (postId) => http.get(endpoint.advertising.GET_POST(postId)).then((res) => res.data),

  getReports: (params) =>
    http
      .get(endpoint.advertising.GET_REPORTS, {
        params,
        responseType: 'blob',
      })
      .then((res) => res.data),

  getRevenueEvents: (params) =>
    http.get(endpoint.advertising.GET_REVENUE_EVENTS, { params }).then((res) => res.data),

  getRevenueEvent: (eventId) =>
    http.get(endpoint.advertising.GET_REVENUE_EVENT(eventId)).then((res) => res.data),

  getWalletCredits: (params) =>
    http.get(endpoint.advertising.GET_WALLET_CREDITS, { params }).then((res) => res.data),

  getWalletCredit: (transactionId) =>
    http.get(endpoint.advertising.GET_WALLET_CREDIT(transactionId)).then((res) => res.data),
};
